module.exports = __webpack_public_path__ + "img/icon-employees-light-gray.ea74cf70.svg";